<footer class="footer d-flex flex-column flex-md-row align-items-center justify-content-between px-4 py-3 border-top small">
  <p class="text-blue mb-1 mb-md-0">{{ "Copyright"|translate }} © {{currentYear}} <a href="" target="_blank">MoneXUi</a>.</p>
</footer>
